import Head from 'next/head';
import React, { useEffect } from 'react';
import { PrivacyPolicy } from '../../components';
import { withLayout } from '../../Layout/Layout';

export const PrivacyPolicyHOC = ({ setCookieAccepted }) => {
  useEffect(() => {
    setTimeout(() => {
      setCookieAccepted({
        accepted: false,
        opened: false,
      });
    }, 0);

  }, [setCookieAccepted]);
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/privacy_policy`}/>
      </Head>
      <PrivacyPolicy/>
    </>
  );
};
export default withLayout(PrivacyPolicyHOC, true);
